import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="a">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Vishnu Rathore </span>
            from <span className="purple"> Nagpur, India.</span>
            <br />Currently, I am pursuing my Undergraduate B.Tech Degree in Computer Science And Engineering from IIIT Nagpur,India.
            <br />
            <br />
            Apart from coding stuff, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games,Cricket
            </li>
            <li className="about-activity">
              <ImPointRight /> Writting Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
